import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Tooltip from 'components/application/Tooltip';

export default function RadioField({
  checked,
  className,
  disabled,
  label,
  labelId,
  name,
  onChange,
  tooltip,
  value,
}) {
  return (
    <div className={classNames('radio-container tooltip-parent', className)}>
      <label
        className={classNames(
          'radio-container__label tw-font-normal',
          checked && 'radio-container__label--active',
          disabled ? 'tw-cursor-default' : 'tw-cursor-pointer',
        )}
        id={labelId}
      >
        <input
          checked={checked}
          disabled={disabled}
          name={name}
          onChange={onChange}
          type='radio'
          value={value}
        />
        <div
          className={classNames(
            'radio-container__outer-circle tw-peer/outer-circle tw-bg-white',
            checked ? 'tw-border-blue-400' : 'tw-border-grey-300',
            disabled ? 'tw-opacity-30'
            : checked ? 'hover:tw-border-blue-500 hover:tw-bg-blue-025'
            : 'hover:tw-border-blue-300',
          )}
        />
        <span
          className={classNames(
            'radio-container__checkmark after:tw-absolute after:tw-m-[6px] after:tw-h-2 after:tw-w-2 after:tw-rounded-full after:tw-bg-blue-400 after:tw-content-[""] peer-hover/outer-circle:after:tw-bg-blue-500',
            checked ? 'after:tw-block' : 'after:tw-hidden',
            disabled && 'tw-opacity-30',
          )}
        />
        <div className='tw-ml-7'>{label}</div>
      </label>
      {disabled && tooltip && (
        <Tooltip
          className='tooltip-dark--max-w-xxs'
          placement='left'
          tooltip={tooltip}
          trigger='hover'
        />
      )}
    </div>
  );
}

RadioField.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
};
